import { createDevTools } from 'redux-devtools';
import LogMonitor from 'redux-devtools-log-monitor';
import DockMonitor from 'redux-devtools-dock-monitor';

import React from 'react';
import { Route, Router } from 'react-router-dom';

import { createStore, combineReducers, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';

import { routerReducer, syncHistoryWithStore, routerMiddleware } from 'react-router-redux';

import thunkMiddleware from 'redux-thunk';
import promiseMiddleware from 'redux-promise-middleware';

import ReactGA from 'react-ga';

import browserHistory from './history';

import * as reducers from './reducers';

// Components
import AboutPage from './containers/AboutPage';
import ContactPage from './containers/ContactPage';
import GalleryPage from './containers/GalleryPage';
import HomePage from './containers/HomePage';
import SchedulePage from './containers/SchedulePage';
import Navigation from './components/Navigation';
import Footer from './components/Footer';

ReactGA.initialize('UA-104512131-1');

const reducer = combineReducers({
  ...reducers,
  routing: routerReducer,
});

const DevTools = createDevTools(
  <DockMonitor toggleVisibilityKey="ctrl-h" changePositionKey="ctrl-q" defaultIsVisible={false}>
    <LogMonitor theme="tomorrow" preserveScrollTop={false} />
  </DockMonitor>,
);

const browserHistoryMiddleware = routerMiddleware(browserHistory)

const store = createStore(
  reducer,
  DevTools.instrument(),
  applyMiddleware(promiseMiddleware(), thunkMiddleware, browserHistoryMiddleware),
);

const history = syncHistoryWithStore(browserHistory, store);

history.listen(() => {
  ReactGA.set({ page: window.location.pathname + window.location.search });
  ReactGA.pageview(window.location.pathname + window.location.search);
});

const makeMainRoutes = () => (
  <Provider store={store}>
    <div>
      <Router history={history} >
        <div>
          <Navigation />
          <Route exact path="/" component={HomePage} />
          <Route exact path="/about" component={AboutPage} />
          <Route exact path="/contact" component={ContactPage} />
          <Route exact path="/gallery" component={GalleryPage} />
          <Route exact path="/schedule" component={SchedulePage} />
          <Footer />
        </div>
      </Router>
    </div>

  </Provider>
);


export default makeMainRoutes;


// WEBPACK FOOTER //
// ./src/routes.jsx